import { Component, OnInit, inject } from '@angular/core';
import { Router, RouterLink } from '@angular/router';
import { FormsModule, NgForm } from '@angular/forms';
import { PageTitleService } from '../../core/services/page-title.service';
import { UserService } from '../../core/services/user.service';
import { OwnerService } from '../../core/services/owner.service';

@Component({
    selector: 'app-user-new',
    imports: [RouterLink, FormsModule],
    template: `
<div class="animated fadeIn">
  <div class="row sfapp-container">
    <div class="col-lg-12">
      <div class="card">
        <div class="card-header">
          <span><i class="fa s-icon-edit"></i>&nbsp;新規作成</span>
        </div>
        <div class="card-body">
          <div style="height: 1px"></div>
          <form novalidate name="userNewForm" #userNewForm="ngForm" (ngSubmit)="save(userNewForm)">
            <div class="row">
              <div class="col-md-12">
                <div class="form-group row">
                  <div class="col-md-4">
                    <label class="col-form-label">所属</label>
                    <select class="form-control" [(ngModel)]="selectedOwner" name="owner" required>
                      <option [ngValue]="null">選択してください</option>
                      @for (owner of owners; track owner.id) {
                        <option [ngValue]="owner">{{owner.name}}</option>
                      }
                    </select>
                  </div>
                </div>
                <div class="form-group row">
                  <div class="col-md-4">
                    <label class="col-form-label">ログイン権限</label>
                    <select class="form-control" [(ngModel)]="user.role" name="role" required>
                      <option value="">選択してください</option>
                      <option value="20">FC管理者</option>
                      <option value="10">本部管理者</option>
                      <option value="1">システム管理者</option>
                    </select>
                  </div>
                </div>
                <div class="form-group row">
                  <div class="col-md-8">
                    <label class="col-form-label">ユーザー名</label>
                    <input type="text" class="form-control" [(ngModel)]="user.name" name="name" required>
                  </div>
                </div>
                <div class="form-group row">
                  <div class="col-md-8">
                    <label class="col-form-label">パスワード</label>
                    <div class="input-group">
                      <input id="password" [type]="showPassword ? 'text' : 'password'" class="form-control" [(ngModel)]="user.password" name="password"
                        [pattern]="passwordPattern" required autocomplete="off"
                        placeholder="半角英字、数字、記号で入力してください">
                      <div class="input-group-append">
                        <button class="btn btn-outline-secondary" type="button" (click)="showPassword = !showPassword">
                          <span [class]="showPassword ? 'fa fa-eye-slash' : 'fa fa-eye'"></span>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="form-group row">
                  <div class="col-md-8">
                    <label class="col-form-label">メールアドレス</label>
                    <input type="email" class="form-control" [(ngModel)]="user.email" name="email" required email>
                  </div>
                </div>
                <div class="form-group row">
                  <div class="col-md-12 text-right">
                    <a routerLink="/user" class="btn bg-close text-white"><i class="fa s-icon-cancel"></i>&nbsp;閉じる</a>
                    <button type="submit" class="btn btn-success" [disabled]="saving || userNewForm.invalid || isInvalid()"><i class="fa s-icon-save"></i>&nbsp;保存</button>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</div>
  `
})
export class UserNewComponent implements OnInit {
  private pageTitleService = inject(PageTitleService);
  private userService = inject(UserService);
  private ownerService = inject(OwnerService);
  private router = inject(Router);

  user: any = { role: '' };
  readonly passwordPattern = /^[0-9a-zA-Z!"#$%&'()*+,\-./:;<=>?@[\\\]^_`{|}~]+$/;
  showPassword = false;
  owners: any[] = [];
  selectedOwner: any = null;
  saving = false;

  async ngOnInit(): Promise<void> {
    this.pageTitleService.set('ユーザーマスター', 's-icon-edit');
    this.owners = await this.ownerService.list('all') ?? [];
  }

  isInvalid(): boolean {
    return !this.selectedOwner || !this.user.role ||
      !this.user.name || !this.user.password || !this.user.email;
  }

  async save(form?: NgForm): Promise<void> {
    if (form?.invalid || this.isInvalid()) {
      form?.control.markAllAsTouched();
      return;
    }
    this.saving = true;
    try {
      const json: any = { ...this.user };
      if (this.selectedOwner) {
        json.ownerId = this.selectedOwner.id;
      }
      await this.userService.upsert(json);
      this.router.navigate(['/user']);
    } finally {
      this.saving = false;
    }
  }
}
